import { checkRole, findServiceArea, getAddressDetails, nonZeroCoordinateValidator, spaceTypeList, parseDisplayName } from './../../../utils/utils.common';
import { Component, OnInit, Input, Output, EventEmitter, ElementRef, OnChanges, SimpleChanges, OnDestroy, ViewChild, ViewChildren, QueryList, AfterViewInit, HostListener, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl, AbstractControl } from '@angular/forms';
import { Observable, Subject, forkJoin } from 'rxjs';
import { sweetAlert } from 'src/app/utils/swal';
import { Router, ActivatedRoute } from '@angular/router';
import { getBrokersList, getstandingOrderDays, legTypeMap } from '../../../utils/utils.common';
import * as moment from 'moment-timezone';
import { SocketService } from 'src/app/service/socket-service/socket-service.service';
import { Events } from 'src/app/utils/event-utils';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { AssigTripsService } from '../assigntrips-service/assigntrips-service';
import { DriversService } from '../../drivers/drivers-service/drivers-service';
import { KeyValue } from '@angular/common';
import { debounceTime, distinctUntilChanged, switchMap, takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { ProTipsServiceService } from '../../helping-material/nemt-pro-tips/service/pro-tips-service.service';
import { imageProcessing } from 'src/app/utils/image-processing-utils';
import { ToastrService } from 'ngx-toastr';
import { TripPurposesService } from '../../trip-purposes/service/trip-purposes.service';
import { MemberService } from '../../members/member-service/member.service';
import { CorporateService } from '../../corporate-user/corporate-service/corporate-service';
import { ModifierCodesService } from '../../modifier-codes/modifier-codes-service/modifier-codes.service';
import { LevelOfServiceService } from '../../level-of-service/service/level-of-service.service';
import { PrimaryDiagnosisService } from '../../primary-diagnosis/primary-diagnosis-service/primary-diagnosis.service';
import { EquipmentService } from '../../equipments/equipment-service/equipment.service';
import { ServiceAreasService } from '../../service-areas/service-areas-service/service-areas.service';
import { AssistService } from 'src/app/service/assist-service/assist.service';
import { ExtractedTripData, matchFundingSource, matchSpaceType } from 'src/app/service/ai-assistant-service/new-trip-extractor.service';
import { MapsAPILoader } from '@agm/core';

@Component({
  selector: 'app-new-trip',
  templateUrl: './new-trip.component.html',
  styleUrls: ['./new-trip.component.css']
})
export class NewTripComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;
  @ViewChild('puDoContainer', { static: false }) puDoContainer?: ElementRef;
  @ViewChild('pickupTimeInputWrapper', { static: false }) pickupTimeInputWrapper?: ElementRef;
  @ViewChild('dropoffTimeInputWrapper', { static: false }) dropoffTimeInputWrapper?: ElementRef;
  @ViewChildren('legContainer') legContainers?: QueryList<ElementRef>;
  @ViewChildren('legPickupTimeInputWrapper') legPickupTimeWrappers?: QueryList<ElementRef>;
  @ViewChildren('legDropoffTimeInputWrapper') legDropoffTimeWrappers?: QueryList<ElementRef>;
  @Input('editId') editId;
  @Input() trip?;
  @Input('isNotAllowToView') isNotAllowToView?;
  @Input() scheduleTime;
  @Input() isStandingOrderClone?;
  @Output() onUpdate = new EventEmitter<string>();
  @Output() onCreate = new EventEmitter<string>();

  newTripForm: FormGroup;
  addonsServicesForm: FormGroup;
  timeZone = "America/New_York";
  todayDate = moment().tz(this.timeZone);
  user;
  search = '';
  fundingSourceList = [];
  tripPurposeList = [];
  modifierList = [];
  levelOfServiceList = [];
  spaceTypeList = [];
  spaceTypeMainList = [];
  serviceAreaList = [];
  primaryDiagnoseList = [];
  addonsList = [];
  filteredAddonsList = [];
  driverList = [];
  isAllowRates = false;
  tripId;
  submitted = false;
  addMemberModalObj = null;
  addressPickerObj;
  assistList;
  selectedAssist = [];
  assignedTrips = [];
  googleMilage = null;
  preCooperates = {};
  preLevelOfServices = {};
  preSpaceTypes = {};
  estAppointmentTime: any;
  suggestedPickupTime;
  isCalculating = false;
  isEditDataLoaded = false;
  isEnableExpectedAppointment = false;
  isPossibility = false;
  possibilityObj;
  allowByWeeklyStandingOrders = false;
  isAiImportOpen = false;
  isAiPopulating = false;
  geoCoder: any;
  isPuDoMileageBased = false;
  isUpdatingPuDoTime: {
    pickup: boolean;
    dropoff: boolean;
    index?: number | null;
  } = {
    pickup: false,
    dropoff: false,
    index: null
  };
  isCalulatePuDo = true;
  timeConnectorPath = '';
  timeConnectorMidX = 0;
  timeConnectorMidY = 0;
  legConnectorPaths: string[] = [];
  legConnectorCenters: { x: number; y: number }[] = [];
  legTypeMap: any = legTypeMap;
  private resizeObserver?: any;
  private mutationObserver?: any;
  private pudoAnimationTimeout?: any;

  get showTimeConnector(): boolean {
    if (!this.isPuDoMileageBased) {
      return false;
    }
    return !!this.isCalulatePuDo;
  }

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private socketService: SocketService,
    private sharedDataService: SharedDataService,
    private assignTripService: AssigTripsService,
    private equipmentService: EquipmentService,
    private proTipsService: ProTipsServiceService,
    private driverService: DriversService,
    private toastr: ToastrService,
    private tripPurposesService: TripPurposesService,
    private memberService: MemberService,
    private corporateService: CorporateService,
    private modifierCodesService: ModifierCodesService,
    private levelOfServiceService: LevelOfServiceService,
    private primaryDiagnosisService: PrimaryDiagnosisService,
    private serviceArea: ServiceAreasService,
    private assistService: AssistService,
    private mapsAPILoader: MapsAPILoader,
    private cdr: ChangeDetectorRef,
  ) {
  }

  ngOnInit() {

    this.newTripForm = this.fb.group({
      company: ['', Validators.required],

      rawId: [''],
      tripId: [''],
      isMedical: [false], // will remove later
      companyType: [''], // will remove later
      jobType: ['cooperate', Validators.required], // will remove later

      jobDestinationAddress: ['', Validators.required],
      jobDestinationLatitude: [0, [Validators.required, nonZeroCoordinateValidator()]],
      jobDestinationLongitude: [0, [Validators.required, nonZeroCoordinateValidator()]],
      zipCodeDest: [''],

      jobOriginAddress: ['', Validators.required],
      jobOriginLatitude: [0, [Validators.required, nonZeroCoordinateValidator()]],
      jobOriginLongitude: [0, [Validators.required, nonZeroCoordinateValidator()]],
      zipCodeOrg: [''],

      client: ['', Validators.required],
      los: ['', Validators.required],
      losDetails: [{}, Validators.required],
      spaceType: ['', Validators.required],
      spaceTypeDetails: [{}, Validators.required],

      priorityClient: this.fb.group({
        displayName: ['', Validators.required],
        contactNumber: ['0000000000'],
        cellPhone: [''],
        clientId: [''],
        email: [''],
        preDob: ['', this.dobValidator],
        dob: [''],
        weight: [''],
        gender: ['']
      }),

      originAddressAdditional: this.fb.group({
        modifier: [''],
        modifierTwo: [''],
        floor: [''],
        room: [''],
        aptOrSuite: [''],
        place: [''],
        phone: ['']
      }),
      destinationAddressAdditional: this.fb.group({
        modifier: [''],
        modifierTwo: [''],
        floor: [''],
        room: [''],
        aptOrSuite: [''],
        place: [''],
        phone: ['']
      }),

      cooperate: ['', Validators.required],
      cooperateDetails: [{}],

      preScheduleTime: ["", Validators.required],
      preAppointmentTime: ["", Validators.required],
      appointmentTime: ["", Validators.required],
      scheduleTime: ["", Validators.required],
      preActualAppointmentTime: [""],
      actualAppointmentTime: [""],
      milage: [null],
      tripLegs: this.fb.array([]),
      addonServices: this.fb.array([]),
      noOfEscorts: [''],
      tripReason: [[]],
      ipa: [''],
      primaryDiagnosis: [''],
      companyNote: [''],
      dispatchNoteTwo: [''],
      attachment: [''],

      preRecurringEndDate: [null],
      recurringEndDate: [''],
      isStandingOrder: [false],
      isRecurring: [false],
      recurringDays: this.fb.array([]),
      isBiWeekly: [false],
      status: [''],
      jobStatus: [''],
      driver: [null],
      events: [[]],
      serviceArea: [''],
      serviceAreaDest: [''],
      // Local Variable
      estimateFare: [{ value: '', disabled: true }],
      isVipTrip: [false],
      preferredDriver: [null],
      isConfirmedTrip: [false],
      isMethadone: [false],
      isDialysis: [false],
      authorizationNumber: [''],
      isWillCall: [false],
      searchMember: [''],
      isEligible: [false],
      isNotEligible: [false]
    });

    if (this.activatedRoute.snapshot.url.length === 3 && this.activatedRoute.snapshot.url[2].path === 'edit') {
      this.tripId = this.activatedRoute.snapshot.url[1].path;
    }

    this.addStandingDays();

    if (this.editId) {
      this.tripId = this.editId;
    }

    if (this.editId || this.tripId || this.trip) {
      this.isCalulatePuDo = false;
    } else {
      this.isCalulatePuDo = true;
    }


    this.makeCompulsoryCalls();
    this.formControlsListeners();
  }

  formControlsListeners() {
    this.newTripForm.controls['jobOriginAddress']
      .valueChanges
      .subscribe(value => {
        if (!value) this.suggestedPickupTime = null;
      });

    this.newTripForm.controls['jobDestinationAddress']
      .valueChanges
      .subscribe(value => {
        if (!value) this.suggestedPickupTime = null;
      });

    this.newTripForm.valueChanges
      .subscribe(formValue => {
        const requiredFields = [
          'jobOriginLatitude',
          'jobOriginLongitude',
          'jobDestinationLatitude',
          'jobDestinationLongitude',
          'jobDestinationAddress',
          'jobOriginAddress',
          'cooperate',
          'spaceType',
          'scheduleTime',
          // 'milage',
          'appointmentTime',
          // 'serviceArea'
        ];
        const isValid = requiredFields.every(
          field => {

            return formValue[field] !== null && formValue[field] !== ''
          }
        );
        this.possibilityObj = isValid ? formValue : null;
      });

  }

  setFormFromInputTrip(data) {
    this.isCalulatePuDo = false;
    console.log(data);
    const preData = JSON.parse(JSON.stringify(data));

    this.newTripForm.patchValue({
      ...preData,
      preScheduleTime: moment(preData.scheduleTime).tz(this.timeZone),
      preAppointmentTime: moment(preData.appointmentTime).tz(this.timeZone)
    });

    if (data.cooperate) {
      this.getAddonsList(data.cooperate);
    }
  }

  makeCompulsoryCalls() {
    const requests = [
      this.getLevelOfService(),
      this.getSpaceTypeList(),
    ];

    // Make all requests in parallel
    forkJoin(requests).subscribe(
      ([res1, res2]) => {

        if (res1) {
          this.levelOfServiceList = res1;
          this.preLevelOfServices = res1.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
        if (res2) {
          this.spaceTypeMainList = res2;
          this.preSpaceTypes = res2.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }

        this.getTripPurposeList();
        this.getFundingSourceList();
        this.getModifierList();
        this.getPrimaryDiagnoseList();
        // this.getAddonsList();
        this.getAssisData()
        this.getUser();
        this.getServiceAreaList();

      },
      error => {
        sweetAlert('Error', error, 'error', 'OK');
      }
    );
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.timeZone = this.user.timeZone;
          this.todayDate = moment().tz(this.timeZone);

          this.newTripForm.patchValue({
            company: this.user._id,

            preScheduleTime: this.todayDate,
            scheduleTime: this.todayDate.toISOString(),

            preAppointmentTime: moment(this.todayDate).add(1, 'hours'),
            appointmentTime: moment(this.todayDate).add(1, 'hours').toISOString(),

            preActualAppointmentTime: moment(this.todayDate).add(1, 'hours'),
            actualAppointmentTime: moment(this.todayDate).add(1, 'hours').toISOString(),
          });

          if (!this.isEnableExpectedAppointment) {
            this.clearExpectedAppointmentValidation();
          }
          if (this.scheduleTime) {
            this.newTripForm.patchValue({
              preScheduleTime: this.scheduleTime,
              scheduleTime: this.scheduleTime.toISOString(),
              preAppointmentTime: moment(this.scheduleTime).add(1, 'hours'),
              appointmentTime: moment(this.scheduleTime).add(1, 'hours').toISOString(),
            });
          }
          this.getDriverList();

          if (this.tripId) {
            this.getTripDetails();
          }

          if (this.trip) {
            this.setFormFromInputTrip(this.trip);
          }

          this.isAllowRates = checkRole(this.user);

          if (this.user.hasOwnProperty('allowByWeeklyStandingOrders')) {
            this.allowByWeeklyStandingOrders = this.user.allowByWeeklyStandingOrders;
          }

          if (this.user.hasOwnProperty('isPuDoMileageBased')) {
            this.isPuDoMileageBased = this.user.isPuDoMileageBased;
            this.scheduleUpdateConnector(50);
          }
        }
      });
  }

  getTripDetails() {
    this.assignTripService
      .getUnassignedTripDetailById(this.tripId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          // bypass normal trip to standingorder trip
          if (this.isStandingOrderClone) {
            data.jobStatus = "standing"
            data.status = "standing"
            data.isRecurring = true
            data.recurringEndDate = ''
            data.driver = null;
          }
          this.preparedDatePatch(data)
          this.scheduleUpdateConnector(200);
          setTimeout(() => {
            this.isEditDataLoaded = true;
            this.scheduleUpdateConnector(50);
          }, 3000);
        }
      }, err => {
        sweetAlert('Error', err, 'error', 'OK');
      });
  }


  getTripPurposeList() {
    this.tripPurposesService
      .getTripPurposesList('active')
      .subscribe(data => {
        if (data) {
          this.tripPurposeList = data;
        }
      });
  }

  getFundingSourceList() {
    this.corporateService
      .getCorporateUsers('active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.preCooperates = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          // this.fundingSourceList = data;
          this.fundingSourceList = data.filter(x => !x.isTripModificationNotAllowed && x.companyType !== 'taxi');
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getModifierList() {
    this.modifierCodesService
      .getModifierCodes()
      .subscribe(data => {
        if (data) {
          this.modifierList = data;
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getLevelOfService() {

    return this.levelOfServiceService.getLevelOfServices({ status: 'active' });
  }

  getSpaceTypeList() {

    return this.levelOfServiceService.getSpaceTypes({ status: 'active' });
  }

  getPrimaryDiagnoseList() {
    this.primaryDiagnosisService
      .getPrimaryDiagnosis()
      .subscribe(data => {
        if (data) {
          this.primaryDiagnoseList = data;
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getAddonsList(fundingSourceId) {
    //add params to send the cooperate key in the equipment api
    let queryParams = {
      isAddon: true,
      cooperate: fundingSourceId
    }
    this.equipmentService
      .getEquipments(queryParams)
      .subscribe(data => {
        if (data) {
          this.addonsList = data;
          this.filteredAddonsList = data;
          this.onSelectSpaceType();

        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getDriverList() {
    this.driverService
      .getDrivers(this.user._id, 'active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.driverList = data;
        }
      });
  }

  get form() {
    return this.newTripForm.controls;
  }

  get legForm() {
    return this.newTripForm.get('tripLegs') as FormArray;
  }

  addLegItem() {
    const items = this.newTripForm.get('tripLegs') as FormArray;
    const preValues = this.newTripForm.value;
    let hour = (items.length * 2) + 1


    const FIELD_MAP = [
      { prev: 'jobDestinationAddress', new: 'jobOriginAddress' },
      { prev: 'jobDestinationLatitude', new: 'jobOriginLatitude' },
      { prev: 'jobDestinationLongitude', new: 'jobOriginLongitude' },
      { prev: 'zipCodeDest', new: 'zipCodeOrg' },
      { prev: 'serviceAreaDest', new: 'serviceArea' }
    ];

    const newLeg = this.fb.group({
      jobDestinationAddress: [preValues.jobOriginAddress, Validators.required],
      jobDestinationLatitude: [preValues.jobOriginLatitude, [Validators.required, nonZeroCoordinateValidator()]],
      jobDestinationLongitude: [preValues.jobOriginLongitude, [Validators.required, nonZeroCoordinateValidator()]],
      zipCodeDest: [preValues.zipCodeOrg],
      serviceAreaDest: [preValues.serviceArea],

      jobOriginAddress: [preValues.jobDestinationAddress, Validators.required],
      jobOriginLatitude: [preValues.jobDestinationLatitude, [Validators.required, nonZeroCoordinateValidator()]],
      jobOriginLongitude: [preValues.jobDestinationLongitude, [Validators.required, nonZeroCoordinateValidator()]],
      zipCodeOrg: [preValues.zipCodeDest],
      serviceArea: [preValues.serviceAreaDest],

      preScheduleTime: [moment(preValues.preAppointmentTime).add(hour, 'hours'), Validators.required],
      scheduleTime: [moment(preValues.preAppointmentTime).add(hour, 'hours').toISOString(), Validators.required],

      preAppointmentTime: [moment(preValues.preAppointmentTime).add(hour + 1, 'hours'), Validators.required],
      appointmentTime: [moment(preValues.preAppointmentTime).add(hour + 1, 'hours').toISOString(), Validators.required],

      companyNote: [''],
      isWillCall: [false],
      estimatedTime: [''],

      originAddressAdditional: this.fb.group({
        modifier: [preValues.destinationAddressAdditional.modifier],
        modifierTwo: [preValues.destinationAddressAdditional.modifierTwo],
        floor: [preValues.destinationAddressAdditional.floor],
        room: [preValues.destinationAddressAdditional.room],
        aptOrSuite: [preValues.destinationAddressAdditional.aptOrSuite],
        place: [preValues.destinationAddressAdditional.place],
        phone: [preValues.destinationAddressAdditional.phone]
      }),
      destinationAddressAdditional: this.fb.group({
        modifier: [preValues.originAddressAdditional.modifier],
        modifierTwo: [preValues.originAddressAdditional.modifierTwo],
        floor: [preValues.originAddressAdditional.floor],
        room: [preValues.originAddressAdditional.room],
        aptOrSuite: [preValues.originAddressAdditional.aptOrSuite],
        place: [preValues.originAddressAdditional.place],
        phone: [preValues.originAddressAdditional.phone]
      }),
    });

    items.push(newLeg);

    if (items.length > 1) {
      const prevLeg = items.at(items.length - 2) as FormGroup;
      const currentLeg = items.at(items.length - 1) as FormGroup;

      const createLink = (prevPath: string, newPath: string) => {
        prevLeg.get(prevPath).valueChanges.subscribe(value =>
          currentLeg.get(newPath).patchValue(value, { emitEvent: false })
        )
      };

      FIELD_MAP.forEach(({ prev, new: newPath }) => createLink(prev, newPath));

      (prevLeg.get('destinationAddressAdditional') as FormGroup).valueChanges.subscribe(value =>
        (currentLeg.get('originAddressAdditional') as FormGroup).patchValue(value, { emitEvent: false }));

      if (items.length > 1) {
        const resetValues = {
          jobDestinationAddress: null,
          jobDestinationLatitude: null,
          jobDestinationLongitude: null,
          zipCodeDest: null,
          serviceAreaDest: null,
          destinationAddressAdditional: {
            modifier: null,
            modifierTwo: null,
            floor: null,
            room: null,
            aptOrSuite: null,
            place: null,
            phone: null
          }
        };
        prevLeg.patchValue(resetValues);
      }
    }
    this.scheduleUpdateConnector(100);
  }

  removeLegItem(index: any) {
    const items = this.newTripForm.get('tripLegs') as FormArray;
    items.removeAt(index);
    if (this.legConnectorPaths && this.legConnectorPaths.length > index) {
      this.legConnectorPaths.splice(index, 1);
    }
    if (this.legConnectorCenters && this.legConnectorCenters.length > index) {
      this.legConnectorCenters.splice(index, 1);
    }
    this.scheduleUpdateConnector(50);
  }

  get addonsForm() {
    return this.newTripForm.get('addonServices') as FormArray;
  }

  addAddonsItem(preAddonList?) {
    const items = this.newTripForm.get('addonServices') as FormArray;

    if (preAddonList) {
      for (const addon of preAddonList) {
        items.push(
          this.fb.group({
            addonId: [addon.addonId, Validators.required],
            quantity: [addon.quantity, [Validators.required, Validators.min(1)]],
            title: [addon.title],
            fare: [addon.fare],
            code: [addon.code],
            total: [addon.total]
          })
        );

      }
      return;
    }

    // if (!items.invalid) {
    items.push(
      this.fb.group({
        addonId: ['', Validators.required],
        quantity: [1, [Validators.required, Validators.min(1)]],
        title: [''],
        fare: [0],
        code: [0],
        total: [0]
      })
    );
    // }
  }

  removeAddonsItem(index: any) {
    const items = this.newTripForm.get('addonServices') as FormArray;
    items.removeAt(index);
  }


  onSelectMember(member) {
    if (member) {
      this.newTripForm.patchValue({
        client: member._id,
        searchMember: member.displayName,
        isEligible:  member.isEligible,
        isNotEligible: member.isNotEligible,
        isVipTrip: member.isVipTrip ? true : false,
        isConfirmedTrip: member.isConfirmedTrip ? true : false,
        isMethadone: member.isMethadone ? true : false,
        isDialysis: member.isDialysis ? true : false,
      });
      this.setMemberDetails(member);
      this.getMemberTrips(member);
    } else {
      this.newTripForm.patchValue({
        client: '',
        isVipTrip: false,
        isConfirmedTrip: false,
        isMethadone: false,
        isDialysis: false,
      });
    }
  }

  setMemberDetails(member) {
    try {
      if (member) {
        console.log('member', member);
        let memberPayload: any = {
          searchMember: member.displayName,
          priorityClient: member,
          isVipTrip: member.isVipTrip ? true : false,
          isConfirmedTrip: member.isConfirmedTrip ? true : false,
          isMethadone: member.isMethadone ? true : false,
          isDialysis: member.isDialysis ? true : false,
          preferredDriver: member.preferredDriver ? member.preferredDriver : null,
          originAddressAdditional: {
            phone: member.contactNumber || '',
            aptOrSuite: (member.homeAddress && member.homeAddress.aptOrSuite) ? member.homeAddress.aptOrSuite : '',
          },
          dispatchNoteTwo: (member.note || '') + (member.privateNote ? (" ----------  " + member.privateNote) : ''),
        }

        if (member.homeAddress && member.homeAddress.address) {
          const myServiceArea = findServiceArea(member.homeAddress.zipCode, this.serviceAreaList);
          memberPayload = {
            ...memberPayload, jobOriginAddress: member.homeAddress.address,
            jobOriginLatitude: member.homeAddress.latitude,
            jobOriginLongitude: member.homeAddress.longitude,
            zipCodeOrg: member.homeAddress.zipCode,
            serviceArea: myServiceArea
          };
        }

        if (member.homeAddress && member.homeAddress.name) {
          memberPayload = {
            ...memberPayload,
            originAddressAdditional: {
              ...memberPayload.originAddressAdditional,
              place: member.homeAddress.name,
            }
          };
        }

        if (member.fundingSource) {
          memberPayload = { ...memberPayload, cooperate: member.fundingSource };
        }

        if (member.spaceType) {
          memberPayload = { ...memberPayload, spaceType: member.spaceType, los: member.los };
        }
        if (member.dob) {
          memberPayload = {
            ...memberPayload,
            priorityClient: {
              ...memberPayload.priorityClient,
              preDob: moment(member.dob).format('MM/DD/YYYY'),
              dob: member.dob
            }

          };

          console.log('memberPayload', memberPayload);
        }

        this.newTripForm.patchValue(memberPayload);

        //  if (member.spaceType) {
        //   this.newTripForm.patchValue({
        //     los: member.los,
        //     spaceType: member.spaceType
        //   });
        //   // this.onSelectLOS(member.los);
        // }

      } else {
        this.newTripForm.patchValue({
          searchMember: '',
          priorityClient: {
            displayName: '',
            contactNumber: '',
            cellPhone: '',
            clientId: '',
            email: '',
            dob: '',
            weight: '',
            gender: ''
          },
          isVipTrip: false,
          isConfirmedTrip: false,
          isMethadone: false,
          isDialysis: false,
        });
      }
    } catch (err) {
      (err);
    }
  }

  setOriginAddress(place, index?) {
    const addressDetails = place ? getAddressDetails(place) : undefined;
    const zip = addressDetails.zipCode;
    const myServiceArea = findServiceArea(zip, this.serviceAreaList);

    if (index > -1) {
      const items = this.newTripForm.get('tripLegs') as FormArray;
      items.at(index).patchValue({
        jobOriginAddress: place.formatted_address,
        jobOriginLatitude: place.geometry.location.lat(),
        jobOriginLongitude: place.geometry.location.lng(),
        zipCodeOrg: zip,
        serviceArea: myServiceArea
      });
    } else {
      this.newTripForm.patchValue({
        jobOriginAddress: place.formatted_address,
        jobOriginLatitude: place.geometry.location.lat(),
        jobOriginLongitude: place.geometry.location.lng(),
        zipCodeOrg: zip,
        serviceArea: myServiceArea
      });
      this.calculateSuggestedPickupTime(); // calling order matters
    }
  }

  setDestinationAddress(place, index?) {
    const addressDetails = place ? getAddressDetails(place) : undefined;
    const zip = addressDetails.zipCode;
    const myServiceArea = findServiceArea(zip, this.serviceAreaList);
    if (index > -1) {
      const items = this.newTripForm.get('tripLegs') as FormArray;
      items.at(index).patchValue({
        jobDestinationAddress: place.formatted_address,
        jobDestinationLatitude: place.geometry.location.lat(),
        jobDestinationLongitude: place.geometry.location.lng(),
        zipCodeDest: zip,
        serviceAreaDest: myServiceArea
      });
    } else {
      this.newTripForm.patchValue({
        jobDestinationAddress: place.formatted_address,
        jobDestinationLatitude: place.geometry.location.lat(),
        jobDestinationLongitude: place.geometry.location.lng(),
        zipCodeDest: zip,
        serviceAreaDest: myServiceArea
      });
      this.calculateSuggestedPickupTime(); // calling order matters
    }
  }

  setPickTimeChange(event, index?) {
    if (this.isAiPopulating || this.isUpdatingPuDoTime.pickup || this.isUpdatingPuDoTime.dropoff) return;
    if (index > -1) {
      const items = this.newTripForm.get('tripLegs') as FormArray;
      const legGroup = items.at(index) as FormGroup;
      const isLegWillCall = legGroup && legGroup.get('isWillCall') && legGroup.get('isWillCall').value;
      items.at(index).patchValue({
        scheduleTime: moment(event).tz(this.timeZone, true).toISOString(),
      });

      if (!this.tripId) {
        if (moment(event).tz(this.timeZone).format("HHmm") == '2359') {
          items.at(index).patchValue({
            preAppointmentTime: moment(event)
          });
        } else {
          if (!isLegWillCall && this.isCalulatePuDo && this.isPuDoMileageBased && this.hasBothAddressAndCoords(index)) {
            this.calculatePuDoTime(true, index);
          } else {
            items.at(index).patchValue({
              preAppointmentTime: moment(event).add(1, 'hours')
            });
          }
        }
      } else {
        if (!isLegWillCall && this.isCalulatePuDo && this.isPuDoMileageBased && this.hasBothAddressAndCoords(index)) {
            this.calculatePuDoTime(true, index);
        }
      }

    } else {
      const isMainWillCall = this.newTripForm.get('isWillCall') && this.newTripForm.get('isWillCall').value;
      this.newTripForm.patchValue({
        scheduleTime: moment(event).tz(this.timeZone, true).toISOString(),
      });

      if (!this.tripId) {
        if (!isMainWillCall && this.isCalulatePuDo && this.isPuDoMileageBased && this.hasBothAddressAndCoords()) {
          this.calculatePuDoTime(true);
        } else {
          this.newTripForm.patchValue({
            preAppointmentTime: moment(event).add(1, 'hours')
          });
          this.calculateEstAppointmentTime()
        }
      } else {
        if (!isMainWillCall && this.isCalulatePuDo && this.isPuDoMileageBased && this.hasBothAddressAndCoords()) {
          this.calculatePuDoTime(true);
        }
      }
    }
  }

  setDropOffTimeChange(event, index?) {
    if (this.isAiPopulating || this.isUpdatingPuDoTime.pickup || this.isUpdatingPuDoTime.dropoff) return;
    if (index > -1) {
      const items = this.newTripForm.get('tripLegs') as FormArray;
      const legGroup = items.at(index) as FormGroup;
      const isLegWillCall = legGroup && legGroup.get('isWillCall') && legGroup.get('isWillCall').value;
      items.at(index).patchValue({
        appointmentTime: moment(event).tz(this.timeZone, true).toISOString(),
      });
      if (!isLegWillCall && this.isCalulatePuDo && this.isPuDoMileageBased && this.hasBothAddressAndCoords(index)) {
        this.calculatePuDoTime(false, index);
      }
    } else {
      const isMainWillCall = this.newTripForm.get('isWillCall') && this.newTripForm.get('isWillCall').value;
      this.newTripForm.patchValue({
        appointmentTime: moment(event).tz(this.timeZone, true).toISOString(),
      });
      if (!isMainWillCall && this.isCalulatePuDo && this.isPuDoMileageBased && this.hasBothAddressAndCoords()) {
        this.calculatePuDoTime(false);
      } else {
        this.calculateEstAppointmentTime();
      }
    }
  }

  setActualAppointmentTimeChange(event) {
    if (!event) return;
    this.newTripForm.patchValue({
      actualAppointmentTime: moment(event).tz(this.timeZone, true).toISOString(),
    });
    this.calculateSuggestedPickupTime(); // calling order matters
  }

  setWillCall(event, index) {
    const items = this.newTripForm.get('tripLegs') as FormArray;
    const legForm = items.at(index) as FormGroup;
    if (event.target.checked) {
      if (legForm) {
        legForm.patchValue({ isWillCall: true });
      }
      if (index == 0) {
        (this.legForm.at(index) as FormGroup).patchValue({
          estimatedTime: this.estAppointmentTime
        });
      }

      const time = items.at(index)['controls'].preScheduleTime.value;
      if (time) {
        time.set('hour', 23);
        time.set('minute', 59);
        items.at(index)['controls'].preScheduleTime.setValue(time);
      }

      items.at(index)['controls'].preScheduleTime.disable();
    } else {
      if (legForm) {
        legForm.patchValue({ isWillCall: false });
      }
      if (index == 0) {
        (this.legForm.at(index) as FormGroup).patchValue({
          estimatedTime: ''
        });
      }
      items.at(index)['controls'].preScheduleTime.enable();
    }

  }

  setWillCallInEdit(event) {
    this.newTripForm.patchValue({ isWillCall: event.target.checked });
    if (event.target.checked) {
      const schTime = this.newTripForm['controls'].preScheduleTime.value;
      schTime.set('hour', 23)
      schTime.set('minute', 59)
      this.newTripForm['controls'].preScheduleTime.setValue(schTime);
      this.newTripForm['controls'].preScheduleTime.disable();

      // const aptTime = this.newTripForm['controls'].preAppointmentTime.value;
      schTime.set('hour', 23)
      schTime.set('minute', 59)
      this.newTripForm['controls'].preAppointmentTime.setValue(schTime);
      this.newTripForm['controls'].preAppointmentTime.disable();
    } else {
      this.newTripForm['controls'].preScheduleTime.enable();
      this.newTripForm['controls'].preAppointmentTime.enable();
    }
  }

  onSelectFundingSource(event) {
    this.newTripForm.patchValue({
      cooperateDetails: {
        displayName: '',
        profileImageURL: ''
      }
    });

    const fundingSource = this.fundingSourceList.find((fundingSource) => fundingSource._id === event);
    if (fundingSource) {
      this.newTripForm.patchValue({
        cooperateDetails: {
          displayName: fundingSource.displayName,
          profileImageURL: fundingSource.profileImageURL
        }
      });
      //Additional Code removed, clearing the array on change of funding source
      this.getAddonsList(fundingSource._id);
    }
    const addonServices = this.newTripForm.get('addonServices') as FormArray;
    // addonServices.clear();
  }

  // onSelectLOS(losId) {
  //   this.spaceTypeList = [];
  //   if (!losId) {
  //     this.newTripForm.patchValue({
  //       spaceType: ''
  //     });
  //     return;
  //   };

  //   this.spaceTypeList = this.spaceTypeMainList.filter(item => item.los === losId);
  //   const spaceTypes = this.spaceTypeList.filter(spaceTypeItem => spaceTypeItem._id === this.newTripForm.value.spaceType);
  //   if (!spaceTypes.length) {
  //     this.newTripForm.patchValue({
  //       spaceType: '',
  //     });
  //   }
  // }

  onSelectSpaceType() {
    this.newTripForm.patchValue({ los: '' });
    if (this.newTripForm.value.spaceType) {
      const selectedSpaceType = this.spaceTypeMainList.find(item => item._id === this.newTripForm.value.spaceType);
      if (selectedSpaceType && selectedSpaceType.los) {
        this.newTripForm.patchValue({
          los: selectedSpaceType.los,
        });
      }
    }
    const addonServices = this.newTripForm.get('addonServices') as FormArray;
    // addonServices.clear();
    this.filteredAddonsList = this.addonsList.filter(item => item.spaceType === this.newTripForm.value.spaceType)
  }


  onSelectAddonItem(addonItem) {
    if (!addonItem.value.addonId || !addonItem.value.quantity) return;

    const item = this.addonsList.find(item => item._id === addonItem.value.addonId);
    addonItem.patchValue({
      ...item,
      total: item.fare * addonItem.value.quantity
    });
  }

  async fileProcessing(ImageInput, form) {
    imageProcessing(ImageInput)
      .subscribe(async (result) => {
        const data: any = await this.proTipsService.changeCoverImage(result.file).toPromise();
        form.setValue(data.location);
      })
  }

  removeFile() {
    this.newTripForm.patchValue({ attachment: '' });
    this.fileInput.nativeElement.value = '';
  }


  get standingOrderForm() {
    return this.newTripForm.get('recurringDays') as FormArray;
  }

  addStandingDays(preStandingList?) {

    const recurringDaysItems = this.newTripForm.get('recurringDays') as FormArray;
    if (preStandingList) {

      for (let preItem of preStandingList) {
        const index = recurringDaysItems.controls.findIndex(item => item.value.day === preItem.day);
        if (index > -1) {
          recurringDaysItems.at(index).patchValue({
            checked: true,
            driver: preItem.driver ? preItem.driver : 'null'
          });

          recurringDaysItems.at(index)['controls'].driver.enable();
        }
      }
      return;
    }

    for (let dayItem of getstandingOrderDays) {
      recurringDaysItems.push(
        this.fb.group({
          label: [dayItem.label],
          day: [dayItem.day],
          checked: [false],
          driver: [{ value: 'null', disabled: true }],
        })
      );
    }
  }

  onChangeStandingDay(event, form) {
    if (event) {
      form.controls.driver.enable();
    } else {
      form.controls.driver.disable();
    }
  }

  onChangeStandingStatus(event) {
    const isEnabled = JSON.parse(event.target.value);
    if (this.tripId && !isEnabled) {
      sweetAlert('Alert', 'Are you sure you want to inactive standing orders? This action will reset the recurring date to today and remove all the future existing trips.', 'warning', 'Yes', 'No')
        .then((result: any) => {
          if (result.value) {
            const standingOrderDate = moment().tz(this.timeZone, true).startOf('day');
            if (this.newTripForm.value.recurringEndDate) {
              const previousDate = moment(this.newTripForm.value.recurringEndDate).tz(this.timeZone, true).startOf('day');
              if (previousDate.isAfter(standingOrderDate)) {
                this.newTripForm.patchValue({
                  preRecurringEndDate: standingOrderDate,
                  recurringEndDate: standingOrderDate.toISOString(),
                  isRecurring: isEnabled
                });
              } else {
                this.newTripForm.patchValue({
                  isRecurring: isEnabled
                });
              }
            } else {
              this.newTripForm.patchValue({
                preRecurringEndDate: standingOrderDate,
                recurringEndDate: standingOrderDate.toISOString(),
                isRecurring: isEnabled
              });
            }
          } else {
            this.newTripForm.patchValue({
              isRecurring: true
            });
          }
        });
    } else {
      this.newTripForm.patchValue({
        isRecurring: isEnabled
      });
    }
  }

  setStandingDateChange(event) {
    if (event) {
      this.newTripForm.patchValue({
        recurringEndDate: moment(event).tz(this.timeZone, true).startOf('day').toISOString()
      });
    }
  }

  async onCreateTrip() {
    this.validateDOB();
    if (this.tripId) {
      const rest = await this.inProgressTripCheck();
      if (rest && rest.status === 'inprogress') {
        sweetAlert('Alert', 'Inprogress trip cannot be edited', 'warning', 'Okay')
        return;
      }
    }
    this.submitted = true;
    if (this.newTripForm.invalid) return;

    if (!this.newTripForm.value.priorityClient.contactNumber) {
      this.newTripForm.controls.priorityClient.patchValue({
        contactNumber: '0000000000'
      })
    }

    let payload = this.newTripForm.value;
    payload = {
      ...payload,
      attendees: this.selectedAssist && this.selectedAssist.length ? this.selectedAssist : null
    };
    // checking standing orders
    if (payload.isRecurring) {
      let recurringDays = [];
      for (let standingOrderDay of payload.recurringDays) {
        if (standingOrderDay.checked) {
          recurringDays.push({ ...standingOrderDay, driver: standingOrderDay.driver === 'null' ? null : standingOrderDay.driver })
        }
      }

      if (recurringDays.length) {
        payload.recurringDays = recurringDays;
        payload.status = 'standing';
        payload.jobStatus = 'standing';
      }
      if (!payload.milage)
        delete payload.milage
    } else {
      delete payload.recurringDays
      if (!payload.status || !payload.jobStatus) {
        delete payload.status
        delete payload.jobStatus
      }
    }

    if (!payload.originAddressAdditional.modifier) {
      payload.originAddressAdditional.modifier = null
    }

    if (!payload.destinationAddressAdditional.modifier) {
      payload.destinationAddressAdditional.modifier = null
    }
    if (!payload.serviceArea) {
      payload.serviceArea = null;
    }
    if (!payload.serviceAreaDest) {
      payload.serviceAreaDest = null;
    }

    for (let leg of payload.tripLegs) {
      if (!leg.originAddressAdditional.modifier) {
        leg.originAddressAdditional.modifier = null
      }

      if (!leg.destinationAddressAdditional.modifier) {
        leg.destinationAddressAdditional.modifier = null
      }
      if (!leg.serviceArea) {
        leg.serviceArea = null
      }
      if (!leg.serviceAreaDest) {
        leg.serviceAreaDest = null
      }
    }

    if (!this.isEnableExpectedAppointment) {
      payload.actualAppointmentTime = "";
    }

    payload.isEnableExpectedAppointment = this.isEnableExpectedAppointment;

    this.assignTripService
      .createNewTripV2(payload, this.isStandingOrderClone ? null : this.tripId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          if (this.editId || this.scheduleTime) {
            this.onUpdate.emit(data);
          } else {
            this.onCreate.emit(data);
            this.router.navigateByUrl('trips');
          }
        }
      }, err => {
        sweetAlert('Error', err, 'error', 'OK');
      });

  }

  async inProgressTripCheck() {
    const res: any = await this.assignTripService
      .getUnassignedTripDetailById(this.tripId)
      .toPromise();
    return res;
  }

  openAddMemberModal(member) {
    this.addMemberModalObj = member;
  }

  onSaveMember(evt) {
    if (evt) {
      // Update the form with new member details
      this.newTripForm.patchValue({
        client: evt._id
      });

      this.setMemberDetails(evt);
      this.addMemberModalObj = null;
    }
  }





  getServiceAreaList() {
    this.serviceArea
      .getServiceAreas({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.serviceAreaList = data;
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  calculateEstimatedFare() {
    const { jobOriginLatitude, jobOriginLongitude, jobDestinationLatitude, jobDestinationLongitude, scheduleTime, cooperate, spaceType, milage, addonServices } = this.newTripForm.value;

    if (!jobOriginLatitude || !jobOriginLongitude || !jobDestinationLatitude || !jobDestinationLongitude || !scheduleTime || !cooperate || !spaceType) {
      sweetAlert('Alert', 'Please select Pickup, Drop Off address, Space Type, Pickup Time & Funding Source', 'warning', 'Ok')
      return;
    }

    let payload;

    payload = {
      company: this.user._id,
      jobDestinationLatitude: jobDestinationLatitude,
      jobDestinationLongitude: jobDestinationLongitude,
      jobOriginLatitude: jobOriginLatitude,
      jobOriginLongitude: jobOriginLongitude,
      spaceType: spaceType,
      cooperate: cooperate,
      scheduleTime: scheduleTime
    };

    if (milage) {
      payload.milage = milage;
    }

    if (addonServices && addonServices.length) {
      payload = { ...payload, addonServices: addonServices }
    }

    this.assignTripService
      .calculateEstimateFare(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.newTripForm.patchValue({
            estimateFare: data.totalFare
          })
        }
      });
  }

  loadAddressPicker(title, value, address?, lat?, lng?, zipCode?) {
    this.addressPickerObj = { title, value, address, lat, lng, zipCode };
  }

  onAddressPicker(event) {
    this.addressPickerObj = null;
    const items = this.newTripForm.get('tripLegs') as FormArray;
    if (!event) return;

    // For Pickup Addresss
    if (event.reference.value === '0') {
      this.newTripForm.patchValue({
        jobOriginAddress: event.address,
        jobOriginLatitude: event.lat,
        jobOriginLongitude: event.lng,
        zipCodeOrg: event.zipCode
      });
      this.calculateSuggestedPickupTime(); // calling order matters
    } else if (event.reference.value === '1') {
      this.newTripForm.patchValue({
        jobDestinationAddress: event.address,
        jobDestinationLatitude: event.lat,
        jobDestinationLongitude: event.lng,
        zipCodeDest: event.zipCode
      });
      this.calculateSuggestedPickupTime(); // calling order matters
    } else if (event.reference.value === '01') {
      items.at(0).patchValue({
        jobOriginAddress: event.address,
        jobOriginLatitude: event.lat,
        jobOriginLongitude: event.lng,
        zipCodeOrg: event.zipCode
      });
    } else if (event.reference.value === '11') {
      items.at(0).patchValue({
        jobDestinationAddress: event.address,
        jobDestinationLatitude: event.lat,
        jobDestinationLongitude: event.lng,
        zipCodeDest: event.zipCode
      });
    } else if (event.reference.value === '02') {
      items.at(1).patchValue({
        jobOriginAddress: event.address,
        jobOriginLatitude: event.lat,
        jobOriginLongitude: event.lng,
        zipCodeOrg: event.zipCode
      });
    } else if (event.reference.value === '12') {
      items.at(1).patchValue({
        jobDestinationAddress: event.address,
        jobDestinationLatitude: event.lat,
        jobDestinationLongitude: event.lng,
        zipCodeDest: event.zipCode
      });
    }

    if (this.newTripForm.value.jobOriginAddress &&
      this.newTripForm.value.jobOriginLatitude &&
      this.newTripForm.value.jobOriginLongitude &&
      this.newTripForm.value.jobDestinationAddress &&
      this.newTripForm.value.jobDestinationLatitude &&
      this.newTripForm.value.jobDestinationLongitude) {
    }
  }

  onDateChange(evt, control: AbstractControl) {
    if (evt) {
      control.setValue(moment(evt).toISOString());
    }
  }

  dobValidator(control: AbstractControl) {
    const dateValue = control.value;
    if (!dateValue) return null;

    const isValidFormat = moment(dateValue, 'MM/DD/YYYY', true).isValid();
    return isValidFormat ? null : { invalidDateFormat: true };
  }

  validateDOB() {
    const control = this.newTripForm.controls.priorityClient.get('preDob');
    if (control && control.valid) {
      const dateValue = moment(control.value, 'MM/DD/YYYY').toISOString();
      this.newTripForm.controls.priorityClient.patchValue({ dob: dateValue }, { emitEvent: false });
    }
  }

  getAssisData() {
    this.assistService.getAssistList()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.assistList = data;
        }
      });
  }

  getMiles() {
    if (!this.newTripForm.value.jobOriginAddress || !this.newTripForm.value.jobDestinationAddress) {
      sweetAlert('Alert', 'Please select Pickup & Drop Off address', 'warning', 'OK')
      return;
    }

    this.setUpSocketListener();
    let data = {
      origin: this.newTripForm.value.jobOriginLatitude + ',' + this.newTripForm.value.jobOriginLongitude,
      destination: this.newTripForm.value.jobDestinationLatitude + ',' + this.newTripForm.value.jobDestinationLongitude
    };
    this.socketService.emit(Events.GET_MILES_CALL, data);
  }

  setUpSocketListener() {
    this.socketService.addListener(Events.GET_MILES_CALL)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        this.googleMilage = data.message;
        this.socketService.removeListener(Events.GET_MILES_CALL);
        setTimeout(() => {
          this.googleMilage = '';
        }, 5000);
      });
  }

  getMemberTrips(member) {
    this.assignedTrips = [];
    const payload = {
      // displayName: name
      client: member._id,
    };
    this.assignTripService
      .getMemberTrips(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.assignedTrips = data;
        }
      });
  }

  ngAfterViewInit(): void {
    this.scheduleUpdateConnector(100);
    this.scheduleUpdateConnector(400);

    const WinResizeObserver = (window as any).ResizeObserver;
    if (WinResizeObserver) {
      this.resizeObserver = new WinResizeObserver(() => {
        this.updateTimeConnector();
      });
      if (this.puDoContainer && this.puDoContainer.nativeElement) {
        this.resizeObserver.observe(this.puDoContainer.nativeElement);
      }
      if (this.pickupTimeInputWrapper && this.pickupTimeInputWrapper.nativeElement) {
        this.resizeObserver.observe(this.pickupTimeInputWrapper.nativeElement);
      }
      if (this.dropoffTimeInputWrapper && this.dropoffTimeInputWrapper.nativeElement) {
        this.resizeObserver.observe(this.dropoffTimeInputWrapper.nativeElement);
      }
      if (this.legContainers) {
        this.legContainers.forEach((item: ElementRef) => {
          if (item && item.nativeElement) {
            this.resizeObserver.observe(item.nativeElement);
          }
        });
      }
      if (this.legPickupTimeWrappers) {
        this.legPickupTimeWrappers.forEach((item: ElementRef) => {
          if (item && item.nativeElement) {
            this.resizeObserver.observe(item.nativeElement);
          }
        });
      }
      if (this.legDropoffTimeWrappers) {
        this.legDropoffTimeWrappers.forEach((item: ElementRef) => {
          if (item && item.nativeElement) {
            this.resizeObserver.observe(item.nativeElement);
          }
        });
      }
    }

    const WinMutationObserver = (window as any).MutationObserver;
    if (WinMutationObserver) {
      this.mutationObserver = new WinMutationObserver(() => {
        this.scheduleUpdateConnector(30);
      });
      if (this.puDoContainer && this.puDoContainer.nativeElement) {
        this.mutationObserver.observe(this.puDoContainer.nativeElement, {
          childList: true,
          subtree: true,
          attributes: true
        });
      }
      if (this.legContainers) {
        this.legContainers.forEach((item: ElementRef) => {
          if (item && item.nativeElement) {
            this.mutationObserver.observe(item.nativeElement, {
              childList: true,
              subtree: true,
              attributes: true
            });
          }
        });
      }
    }

    if (this.legContainers) {
      this.legContainers.changes.pipe(takeUntil(componentDestroyed(this))).subscribe((list: QueryList<ElementRef>) => {
        if (list) {
          list.forEach((item: ElementRef) => {
            if (item && item.nativeElement) {
              if (this.resizeObserver) {
                this.resizeObserver.observe(item.nativeElement);
              }
              if (this.mutationObserver) {
                this.mutationObserver.observe(item.nativeElement, {
                  childList: true,
                  subtree: true,
                  attributes: true
                });
              }
            }
          });
        }
        if (this.legPickupTimeWrappers) {
          this.legPickupTimeWrappers.forEach((item: ElementRef) => {
            if (item && item.nativeElement && this.resizeObserver) {
              this.resizeObserver.observe(item.nativeElement);
            }
          });
        }
        if (this.legDropoffTimeWrappers) {
          this.legDropoffTimeWrappers.forEach((item: ElementRef) => {
            if (item && item.nativeElement && this.resizeObserver) {
              this.resizeObserver.observe(item.nativeElement);
            }
          });
        }
        this.scheduleUpdateConnector(50);
        this.scheduleUpdateConnector(250);
      });
    }

    if (this.newTripForm && this.newTripForm.valueChanges) {
      this.newTripForm.valueChanges.pipe(
        debounceTime(50),
        takeUntil(componentDestroyed(this))
      ).subscribe(() => {
        this.scheduleUpdateConnector(30);
      });
    }
  }

  ngOnDestroy(): void {
    if (this.pudoAnimationTimeout) {
      clearTimeout(this.pudoAnimationTimeout);
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
    }
  }

  preparedDatePatch(data: any) {
    this.isCalulatePuDo = false;
    const preData = JSON.parse(JSON.stringify(data));
    // remove standing order
    delete preData.recurringDays;
    delete preData.addonServices;

    this.newTripForm.patchValue({
      ...preData,
      preferredDriver : preData.preferredDriver ? preData.preferredDriver : null,
      searchMember: preData.priorityClient.displayName,
      preScheduleTime: moment(preData.scheduleTime).tz(this.timeZone),
      preAppointmentTime: moment(preData.appointmentTime).tz(this.timeZone),
      preActualAppointmentTime: preData.actualAppointmentTime ? moment(preData.actualAppointmentTime).tz(this.timeZone) : '',
      preRecurringEndDate: preData.recurringEndDate ? moment(preData.recurringEndDate).tz(this.timeZone) : null,
      priorityClient: {
        ...preData.priorityClient,
        preDob: preData.priorityClient && preData.priorityClient.dob ? moment(preData.priorityClient.dob).tz(this.timeZone).format('MM/DD/YYYY') : '',
      }
    });
    // this.onSelectLOS(data.los);

    if (data.cooperate) {
      this.getAddonsList(data.cooperate);
    }

    if (data.addonServices) {
      this.addAddonsItem(data.addonServices)
    }

    if (data.status === "standing") {
      this.addStandingDays(data.recurringDays);
    }

    this.selectedAssist = data.attendees;

    this.isEnableExpectedAppointment = !!data.isEnableExpectedAppointment;

    if (!this.isEnableExpectedAppointment) {
      this.clearExpectedAppointmentValidation();
    } else {
      this.form.preActualAppointmentTime.setValidators(Validators.required);
      this.form.preActualAppointmentTime.updateValueAndValidity();
    }
  }

  onSelectHistoryTrip(data) {
    this.preparedDatePatch(data);
  }

  onAppointmentChange(selectedItems) {
    const selectedIds = selectedItems.map(item => item._id);
    this.calculateEstAppointmentTime(selectedIds);
  }

  calculateEstAppointmentTime(appointments?) {
    const preAppointmentTime = this.newTripForm.get('preAppointmentTime').value;
    let totalAppointmentTime = 0;
    if (appointments && appointments.length) {
      let selectedItems = [];
      selectedItems = this.tripPurposeList.filter(item =>
        appointments.includes(item._id)
      );
      totalAppointmentTime = selectedItems.reduce(
        (acc, curr) => acc + (curr.time || 0),
        0
      );
    }

    this.estAppointmentTime = null;
    this.estAppointmentTime = moment(preAppointmentTime)
      .tz(this.timeZone)
      .add(totalAppointmentTime || 60, 'minutes');

  }

  async calculateSuggestedPickupTime() {
    if (!this.isEnableExpectedAppointment) return;
    if (this.tripId && !this.isEditDataLoaded) return; // prevent calculation on edit trip form load
    this.suggestedPickupTime = null;
    const {
      jobOriginAddress,
      jobOriginLatitude,
      jobOriginLongitude,
      jobDestinationAddress,
      jobDestinationLatitude,
      jobDestinationLongitude,
      actualAppointmentTime
    } = this.newTripForm.value;

    // stop if any of the following doesn't have a value
    if (!(jobOriginAddress && jobDestinationAddress && actualAppointmentTime)) return;

    this.isCalculating = true;
    const queryParams = {
      start: [jobOriginLongitude, jobOriginLatitude].toString(),
      end: [jobDestinationLongitude, jobDestinationLatitude].toString(),
    };

    try {
      const minutes = await this.calculateTime(queryParams);
      const estimatedPickupTime = moment(actualAppointmentTime).tz(this.timeZone).subtract(minutes, 'minutes');
      this.suggestedPickupTime = estimatedPickupTime;

      const newScheduleTime = estimatedPickupTime.subtract(20, 'minutes');

      this.newTripForm.patchValue({
        preScheduleTime: newScheduleTime,
        scheduleTime: newScheduleTime.toISOString(),

        preAppointmentTime: newScheduleTime.clone().add(minutes, 'minutes'),
        appointmentTime: newScheduleTime.clone().add(minutes, 'minutes').toISOString(),
      });
      this.isCalculating = false;
    } catch (error) {
      this.isCalculating = false;
    }
  }

  async calculateTime(queryParams) {
    const res: any = await this.assignTripService.calculateMiles(queryParams).pipe(takeUntil(componentDestroyed(this))).toPromise();
    let duration = 60;
    if (
      res &&
      res.features &&
      res.features[0] &&
      res.features[0].properties &&
      res.features[0].properties.segments &&
      res.features[0].properties.segments[0] &&
      res.features[0].properties.segments[0].duration
    ) {
      console.log("calculateMiles: ", res.features[0].properties.segments[0])
      duration = res.features[0].properties.segments[0].duration / 60;
    }

    return duration;
  }

  toggleBiWeeklySO() {
    this.newTripForm.patchValue({
      isBiWeekly: !this.newTripForm.value.isBiWeekly
    });
  }

  openAiImportModal() {
    if (this.tripId || this.editId) {
      return;
    }
    this.isAiImportOpen = true;
  }

  closeAiImportModal() {
    this.isAiImportOpen = false;
  }

  async getTravelTimeMinutes(originLat: number, originLng: number, destLat: number, destLng: number): Promise<number> {
    if (!originLat || !destLat) {
      return 30;
    }

    if (this.mapsAPILoader) {
      try {
        await this.mapsAPILoader.load();
      } catch (e) {}
    }

    // 1. Google Maps DistanceMatrixService
    if ((window as any).google && (window as any).google.maps && (window as any).google.maps.DistanceMatrixService) {
      try {
        const service = new (window as any).google.maps.DistanceMatrixService();
        const durationMin: number | null = await new Promise((resolve) => {
          service.getDistanceMatrix({
            origins: [{ lat: originLat, lng: originLng }],
            destinations: [{ lat: destLat, lng: destLng }],
            travelMode: (window as any).google.maps.TravelMode.DRIVING,
            unitSystem: (window as any).google.maps.UnitSystem.IMPERIAL
          }, (response: any, status: any) => {
            if (
              status === 'OK' &&
              response &&
              response.rows &&
              response.rows[0] &&
              response.rows[0].elements &&
              response.rows[0].elements[0] &&
              response.rows[0].elements[0].status === 'OK'
            ) {
              const seconds = response.rows[0].elements[0].duration.value;
              resolve(Math.ceil(seconds / 60));
            } else {
              resolve(null);
            }
          });
        });

        if (durationMin && durationMin > 0) {
          return durationMin;
        }
      } catch (e) {
        console.warn('DistanceMatrixService error:', e);
      }
    }

    // 2. Fallback to assignTripService.calculateMiles
    try {
      const queryParams = {
        start: [originLng, originLat].toString(),
        end: [destLng, destLat].toString(),
      };
      const duration = await this.calculateTime(queryParams);
      if (duration && duration > 0) {
        return Math.ceil(duration);
      }
    } catch (e) {
      console.warn('calculateMiles error:', e);
    }

    // 3. Fallback: Approximate driving duration from distance between coordinates
    if (originLat && destLat && originLng && destLng) {
      const R = 3958.8; // Earth radius in miles
      const dLat = (destLat - originLat) * Math.PI / 180;
      const dLon = (destLng - originLng) * Math.PI / 180;
      const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(originLat * Math.PI / 180) * Math.cos(destLat * Math.PI / 180) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const straightMiles = R * c;
      const drivingMiles = straightMiles * 1.35; // Route curvature factor
      // Estimate at ~25mph driving + 5min buffer
      return Math.max(15, Math.ceil((drivingMiles / 25) * 60 + 5));
    }

    return 30;
  }

  parseTimeStringToMoment(timeStr: any, baseMoment: moment.Moment): moment.Moment | null {
    if (!timeStr) return null;
    if (timeStr instanceof Date) {
      const d = moment(timeStr);
      return baseMoment.clone().hour(d.hour()).minute(d.minute()).second(0).millisecond(0);
    }
    const str = String(timeStr).trim();
    if (!str || /will\s*call/i.test(str)) return null;

    // Check for Excel fractional day e.g. "0.395833"
    const num = Number(str);
    if (!isNaN(num) && num > 0 && num < 1) {
      const totalSec = Math.round(num * 86400);
      const h = Math.floor(totalSec / 3600);
      const m = Math.floor((totalSec % 3600) / 60);
      return baseMoment.clone().hour(h).minute(m).second(0).millisecond(0);
    }

    const formats = [
      'h:mm:ss A', 'h:mm:ss a', 'hh:mm:ss A', 'hh:mm:ss a',
      'h:mm A', 'h:mm a', 'hh:mm A', 'hh:mm a',
      'HH:mm:ss', 'H:mm:ss',
      'HH:mm', 'H:mm'
    ];

    for (let i = 0; i < formats.length; i++) {
      const parsed = moment(str, formats[i], true);
      if (parsed.isValid()) {
        return baseMoment.clone().hour(parsed.hour()).minute(parsed.minute()).second(0).millisecond(0);
      }
    }

    // Regex fallback for H:mm or HH:mm with optional AM/PM
    const match = str.match(/(\d{1,2})[:.](\d{2})(?::(\d{2}))?\s*(am|pm)?/i);
    if (match) {
      let hours = parseInt(match[1], 10);
      const minutes = parseInt(match[2], 10);
      const meridian = match[4] ? match[4].toLowerCase() : null;
      if (meridian === 'pm' && hours < 12) hours += 12;
      if (meridian === 'am' && hours === 12) hours = 0;
      return baseMoment.clone().hour(hours).minute(minutes).second(0).millisecond(0);
    }

    return null;
  }

  async geocodeAddress(addressStr: string): Promise<any> {
    if (!addressStr || !addressStr.trim()) return null;
    if (this.mapsAPILoader) {
      try {
        await this.mapsAPILoader.load();
      } catch (e) {
        console.warn('MapsAPILoader load error:', e);
      }
    }
    return new Promise((resolve) => {
      if (!this.geoCoder && (window as any).google && (window as any).google.maps) {
        this.geoCoder = new (window as any).google.maps.Geocoder();
      }
      if (!this.geoCoder) {
        resolve(null);
        return;
      }
      this.geoCoder.geocode({ address: addressStr.trim() }, (results: any, status: any) => {
        if (status === 'OK' && results && results[0]) {
          const place = results[0];
          const addressDetails = getAddressDetails(place);
          const zip = addressDetails ? addressDetails.zipCode : '';
          const myServiceArea = findServiceArea(zip, this.serviceAreaList);
          resolve({
            place,
            formatted_address: place.formatted_address || addressStr,
            latitude: place.geometry && place.geometry.location ? place.geometry.location.lat() : 0,
            longitude: place.geometry && place.geometry.location ? place.geometry.location.lng() : 0,
            zipCode: zip,
            serviceArea: myServiceArea,
            city: addressDetails ? addressDetails.city : '',
            state: addressDetails ? addressDetails.state : '',
            street: addressDetails ? addressDetails.street : '',
            aptOrSuite: addressDetails ? addressDetails.aptOrSuite : ''
          });
        } else {
          resolve(null);
        }
      });
    });
  }

  async handleTripExtracted(extracted: ExtractedTripData) {
    if (!extracted) return;
    this.isAiPopulating = true;
    this.toastr.info('Populating trip fields...', 'Importer');

    // 1. Funding Source Matching
    if (extracted.fundingSourceId) {
      this.newTripForm.patchValue({ cooperate: extracted.fundingSourceId });
      this.onSelectFundingSource(extracted.fundingSourceId);
    } else if (extracted.fundingSource || extracted.healthplanCode) {
      const matchedFs = matchFundingSource(
        extracted.fundingSource || extracted.healthplanCode,
        this.fundingSourceList
      );
      if (matchedFs) {
        this.newTripForm.patchValue({ cooperate: matchedFs._id });
        this.onSelectFundingSource(matchedFs._id);
      }
    }

    // 2. Space Type & Level of Service Matching
    if (extracted.modeOfTransport || extracted.spaceType) {
      const matchedSt = matchSpaceType(
        extracted.modeOfTransport || extracted.spaceType,
        this.spaceTypeMainList
      );
      if (matchedSt) {
        this.newTripForm.patchValue({ spaceType: matchedSt._id });
        this.onSelectSpaceType();
      }
    }

    // 3. Geocode Origin & Destination Addresses
    const [geoOrigin, geoDest] = await Promise.all([
      extracted.pickupAddress ? this.geocodeAddress(extracted.pickupAddress) : Promise.resolve(null),
      extracted.dropoffAddress ? this.geocodeAddress(extracted.dropoffAddress) : Promise.resolve(null)
    ]);

    // 4. Match or Create Member
    let matchedMember: any = null;
    const searchKey = (extracted.memberId || extracted.phone || extracted.patientName || '').trim();
    if (searchKey) {
      try {
        const res = await this.memberService.getMembers({ search: searchKey }).toPromise();
        const members = (res && res.data) ? res.data : (Array.isArray(res) ? res : []);
        if (members && members.length > 0) {
          matchedMember = members.find((m: any) =>
            (extracted.memberId && m.clientId && String(m.clientId).trim().toLowerCase() === String(extracted.memberId).trim().toLowerCase()) ||
            (extracted.phone && (m.contactNumber === extracted.phone || m.cellPhone === extracted.phone)) ||
            (extracted.patientName && m.displayName && m.displayName.trim().toLowerCase() === extracted.patientName.trim().toLowerCase())
          ) || members[0];
        }
      } catch (err) {
        console.warn('Error fetching member:', err);
      }
    }

    if (matchedMember) {
      this.onSelectMember(matchedMember);
    } else if (extracted.patientName || extracted.memberId) {
      // Auto-create new member if not exists
      const parsedName = parseDisplayName(extracted.patientName || '');
      const firstName = (parsedName.firstName || extracted.patientName || 'Patient').trim();
      const lastName = (parsedName.lastName || parsedName.firstName || extracted.patientName || 'Member').trim();
      const displayName = (extracted.patientName || `${firstName} ${lastName}`).trim();
      const dobMoment = extracted.dob ? moment(extracted.dob) : null;
      const isoDob = dobMoment && dobMoment.isValid() ? dobMoment.toISOString() : '';

      const newMemberPayload: any = {
        firstName: firstName,
        lastName: lastName,
        displayName: displayName,
        contactNumber: (extracted.contactNumber || extracted.phone || '0000000000').replace(/\D/g, '') || '0000000000',
        clientType: 'patient',
        accountStatus: 'active',
        type: 'regular',
        homeAddress: {
          address: (geoOrigin && geoOrigin.formatted_address) || extracted.pickupAddress || 'Address Pending',
          latitude: (geoOrigin && geoOrigin.latitude) || 0,
          longitude: (geoOrigin && geoOrigin.longitude) || 0,
          zipCode: (geoOrigin && geoOrigin.zipCode) || '',
          city: (geoOrigin && geoOrigin.city) || '',
          state: (geoOrigin && geoOrigin.state) || '',
          street: (geoOrigin && geoOrigin.street) || '',
          aptOrSuite: extracted.pickupApt || (geoOrigin && geoOrigin.aptOrSuite) || '',
          name: extracted.pickupLocationName || ''
        }
      };

      if (parsedName.middleName) {
        newMemberPayload.middleName = parsedName.middleName.trim();
      }
      if (extracted.memberId || extracted.clientId) {
        newMemberPayload.clientId = String(extracted.memberId || extracted.clientId).trim();
      }
      if (extracted.email) {
        newMemberPayload.email = extracted.email.trim();
      }
      if (extracted.cellPhone || extracted.preferredPhone) {
        newMemberPayload.cellPhone = (extracted.cellPhone || extracted.preferredPhone).replace(/\D/g, '');
      }
      if (extracted.gender) {
        newMemberPayload.gender = extracted.gender;
      }
      if (extracted.weight) {
        newMemberPayload.weight = extracted.weight;
      }
      if (isoDob) {
        newMemberPayload.dob = isoDob;
      }
      if (this.newTripForm.value.cooperate) {
        newMemberPayload.fundingSource = this.newTripForm.value.cooperate;
      }
      if (this.newTripForm.value.spaceType) {
        newMemberPayload.spaceType = this.newTripForm.value.spaceType;
      }
      if (this.newTripForm.value.los) {
        newMemberPayload.los = this.newTripForm.value.los;
      }

      try {
        const createRes = await this.memberService.saveMember(null, newMemberPayload).toPromise();
        const createdMember = (createRes && createRes.data) ? createRes.data : createRes;
        if (createdMember && (createdMember._id || createdMember.id)) {
          const memberId = createdMember._id || createdMember.id;
          createdMember._id = memberId;
          this.newTripForm.patchValue({ client: memberId });
          this.toastr.success(`Created member ${createdMember.displayName || displayName}`, 'Member Created');
          this.onSelectMember(createdMember);
        }
      } catch (err) {
        console.error('Failed to auto-create member:', err);
        this.toastr.warning('Could not auto-create member. You can create manually.', 'Member');
      }
    }

    // 5. Member / Priority Client Info (Overlay extracted details on form)
    const dobMoment = extracted.dob ? moment(extracted.dob) : null;
    const formattedDob = dobMoment && dobMoment.isValid() ? dobMoment.format('MM/DD/YYYY') : (extracted.dob || '');
    const isoDob = dobMoment && dobMoment.isValid() ? dobMoment.toISOString() : (extracted.dob || '');

    const patientPayload: any = {
      searchMember: extracted.patientName || this.newTripForm.value.searchMember || '',
      priorityClient: {
        ...(this.newTripForm.value.priorityClient || {}),
        displayName: extracted.patientName || (this.newTripForm.value.priorityClient && this.newTripForm.value.priorityClient.displayName) || '',
        contactNumber: extracted.contactNumber || extracted.phone || (this.newTripForm.value.priorityClient && this.newTripForm.value.priorityClient.contactNumber) || '0000000000',
        cellPhone: extracted.cellPhone || extracted.preferredPhone || extracted.phone || (this.newTripForm.value.priorityClient && this.newTripForm.value.priorityClient.cellPhone) || '',
        clientId: extracted.memberId || extracted.clientId || (this.newTripForm.value.priorityClient && this.newTripForm.value.priorityClient.clientId) || '',
        email: extracted.email || (this.newTripForm.value.priorityClient && this.newTripForm.value.priorityClient.email) || '',
        preDob: formattedDob || (this.newTripForm.value.priorityClient && this.newTripForm.value.priorityClient.preDob) || '',
        dob: isoDob || (this.newTripForm.value.priorityClient && this.newTripForm.value.priorityClient.dob) || '',
        weight: extracted.weight || (this.newTripForm.value.priorityClient && this.newTripForm.value.priorityClient.weight) || '',
        gender: extracted.gender || (this.newTripForm.value.priorityClient && this.newTripForm.value.priorityClient.gender) || ''
      },
      authorizationNumber: extracted.authorizationNumber || this.newTripForm.value.authorizationNumber || '',
      tripId: extracted.tripId || this.newTripForm.value.tripId || '',
      rawId: extracted.rawId || extracted.tripId || this.newTripForm.value.rawId || '',
      ipa: extracted.ipa || '',
      primaryDiagnosis: extracted.primaryDiagnosis || '',
      noOfEscorts: extracted.noOfEscorts ? String(extracted.noOfEscorts) : '',
      companyNote: extracted.companyNote || extracted.notes || '',
      dispatchNoteTwo: extracted.dispatchNote || extracted.specialInstructions || extracted.notes || '',
      isDialysis: Boolean(extracted.isDialysis),
      isMethadone: Boolean(extracted.isMethadone),
      isStandingOrder: Boolean(extracted.isStandingOrder),
      isRecurring: Boolean(extracted.isRecurring),
      isConfirmedTrip: Boolean(extracted.isConfirmedTrip),
      isVipTrip: Boolean(extracted.isVipTrip),
      isWillCall: Boolean(extracted.isWillCall)
    };
    this.newTripForm.patchValue(patientPayload);

    // 6. Trip Purpose / Reason Matching
    if (extracted.tripReason && this.tripPurposeList && this.tripPurposeList.length > 0) {
      const reasonStr = Array.isArray(extracted.tripReason) ? extracted.tripReason.join(' ') : String(extracted.tripReason);
      const matchedPurpose = this.tripPurposeList.find(item => {
        const title = (item.title || item.name || item.purpose || '').toLowerCase();
        return reasonStr.toLowerCase().includes(title) || title.includes(reasonStr.toLowerCase());
      });
      if (matchedPurpose) {
        this.newTripForm.patchValue({
          tripReason: [matchedPurpose._id || matchedPurpose.name || matchedPurpose.title]
        });
      }
    }

    // 7. Date and Times
    const baseDate = extracted.dateOfService ? moment(extracted.dateOfService).startOf('day') : moment().startOf('day');
    const parsedPickup = this.parseTimeStringToMoment(extracted.pickupTime, baseDate);
    const parsedAppt = this.parseTimeStringToMoment(extracted.appointmentTime || extracted.checkInTime, baseDate);

    let pickupMoment: moment.Moment;
    let apptMoment: moment.Moment;

    // Calculate distance-based driving duration between geocoded origin and destination
    const travelMinutes = await this.getTravelTimeMinutes(
      geoOrigin ? geoOrigin.latitude : 0,
      geoOrigin ? geoOrigin.longitude : 0,
      geoDest ? geoDest.latitude : 0,
      geoDest ? geoDest.longitude : 0
    );

    // Priority Rule:
    // 1. If BOTH Pickup Time and Appointment/Dropoff Time exist in the document, assign them directly as Schedule Time and Appointment Time.
    // 2. If only Pickup Time exists, calculate estimated Appointment Time = pickupTime + travelMinutes.
    // 3. If only Appointment/Dropoff Time exists, calculate estimated Schedule Time = appointmentTime - travelMinutes.
    if (parsedPickup && parsedAppt) {
      pickupMoment = parsedPickup;
      apptMoment = parsedAppt;
    } else if (parsedPickup && !parsedAppt) {
      pickupMoment = parsedPickup;
      apptMoment = pickupMoment.clone().add(travelMinutes || 60, 'minutes');
    } else if (!parsedPickup && parsedAppt) {
      apptMoment = parsedAppt;
      pickupMoment = apptMoment.clone().subtract(travelMinutes || 60, 'minutes');
    } else {
      pickupMoment = baseDate.clone().hour(9).minute(0).second(0);
      apptMoment = pickupMoment.clone().add(travelMinutes || 60, 'minutes');
    }

    this.newTripForm.patchValue({
      preScheduleTime: pickupMoment,
      scheduleTime: pickupMoment.toISOString(),
      preAppointmentTime: apptMoment,
      appointmentTime: apptMoment.toISOString()
    });

    // 8. Set Origin / Pickup Address and coordinates
    if (geoOrigin) {
      this.newTripForm.patchValue({
        jobOriginAddress: geoOrigin.formatted_address,
        jobOriginLatitude: geoOrigin.latitude,
        jobOriginLongitude: geoOrigin.longitude,
        zipCodeOrg: geoOrigin.zipCode,
        serviceArea: geoOrigin.serviceArea
      });
    } else if (extracted.pickupAddress) {
      this.newTripForm.patchValue({
        jobOriginAddress: extracted.pickupAddress
      });
    }

    this.newTripForm.patchValue({
      originAddressAdditional: {
        place: extracted.pickupLocationName || '',
        room: extracted.pickupRoom || '',
        floor: extracted.pickupFloor || '',
        aptOrSuite: extracted.pickupApt || (geoOrigin ? geoOrigin.aptOrSuite : ''),
        phone: extracted.pickupPhone || extracted.phone || '',
        modifier: extracted.pickupModifier || '',
        modifierTwo: extracted.pickupModifierTwo || ''
      }
    });

    // 9. Set Destination / Dropoff Address and coordinates
    if (geoDest) {
      this.newTripForm.patchValue({
        jobDestinationAddress: geoDest.formatted_address,
        jobDestinationLatitude: geoDest.latitude,
        jobDestinationLongitude: geoDest.longitude,
        zipCodeDest: geoDest.zipCode,
        serviceAreaDest: geoDest.serviceArea
      });
    } else if (extracted.dropoffAddress) {
      this.newTripForm.patchValue({
        jobDestinationAddress: extracted.dropoffAddress
      });
    }

    this.newTripForm.patchValue({
      destinationAddressAdditional: {
        place: extracted.dropoffLocationName || '',
        room: extracted.dropoffRoom || '',
        floor: extracted.dropoffFloor || '',
        aptOrSuite: extracted.dropoffApt || (geoDest ? geoDest.aptOrSuite : ''),
        phone: extracted.dropoffPhone || '',
        modifier: extracted.dropoffModifier || '',
        modifierTwo: extracted.dropoffModifierTwo || ''
      }
    });

    // 10. Multi-Leg and Round Trip Handling
    const extraLegs = extracted.legs || [];
    const shouldAddLegs = Boolean(extracted.isRoundTrip || extraLegs.length > 0);

    if (shouldAddLegs) {
      const requiredLegCount = Math.max(1, extraLegs.length);

      while (this.legForm.length < requiredLegCount) {
        this.addLegItem();
      }
      while (this.legForm.length > requiredLegCount) {
        this.legForm.removeAt(this.legForm.length - 1);
      }

      setTimeout(() => {
        const currentFormVal = this.newTripForm.value;

        for (let lIdx = 0; lIdx < this.legForm.length; lIdx++) {
          const legGroup = this.legForm.at(lIdx) as FormGroup;
          const legData = extraLegs[lIdx] || null;

          // Origin and Destination for Return/Next Leg (defaults to reverse of trip 1)
          const orgAddr = (legData && legData.pickupAddress) || currentFormVal.jobDestinationAddress;
          const orgLat = (legData && legData.pickupAddress === currentFormVal.jobDestinationAddress) ? currentFormVal.jobDestinationLatitude : currentFormVal.jobDestinationLatitude;
          const orgLng = (legData && legData.pickupAddress === currentFormVal.jobDestinationAddress) ? currentFormVal.jobDestinationLongitude : currentFormVal.jobDestinationLongitude;

          const destAddr = (legData && legData.dropoffAddress) || currentFormVal.jobOriginAddress;
          const destLat = (legData && legData.dropoffAddress === currentFormVal.jobOriginAddress) ? currentFormVal.jobOriginLatitude : currentFormVal.jobOriginLatitude;
          const destLng = (legData && legData.dropoffAddress === currentFormVal.jobOriginAddress) ? currentFormVal.jobOriginLongitude : currentFormVal.jobOriginLongitude;

          legGroup.patchValue({
            jobOriginAddress: orgAddr,
            jobOriginLatitude: orgLat,
            jobOriginLongitude: orgLng,
            zipCodeOrg: currentFormVal.zipCodeDest,
            serviceArea: currentFormVal.serviceAreaDest,

            jobDestinationAddress: destAddr,
            jobDestinationLatitude: destLat,
            jobDestinationLongitude: destLng,
            zipCodeDest: currentFormVal.zipCodeOrg,
            serviceAreaDest: currentFormVal.serviceArea,

            companyNote: (legData && legData.notes) || '',

            originAddressAdditional: {
              modifier: (legData && legData.pickupModifier) || (currentFormVal.destinationAddressAdditional && currentFormVal.destinationAddressAdditional.modifier),
              modifierTwo: (legData && legData.pickupModifierTwo) || (currentFormVal.destinationAddressAdditional && currentFormVal.destinationAddressAdditional.modifierTwo),
              floor: (legData && legData.pickupFloor) || (currentFormVal.destinationAddressAdditional && currentFormVal.destinationAddressAdditional.floor),
              room: (legData && legData.pickupRoom) || (currentFormVal.destinationAddressAdditional && currentFormVal.destinationAddressAdditional.room),
              aptOrSuite: (legData && legData.pickupApt) || (currentFormVal.destinationAddressAdditional && currentFormVal.destinationAddressAdditional.aptOrSuite),
              place: (legData && legData.pickupLocationName) || (currentFormVal.destinationAddressAdditional && currentFormVal.destinationAddressAdditional.place),
              phone: (legData && legData.pickupPhone) || (currentFormVal.destinationAddressAdditional && currentFormVal.destinationAddressAdditional.phone)
            },
            destinationAddressAdditional: {
              modifier: (legData && legData.dropoffModifier) || (currentFormVal.originAddressAdditional && currentFormVal.originAddressAdditional.modifier),
              modifierTwo: (legData && legData.dropoffModifierTwo) || (currentFormVal.originAddressAdditional && currentFormVal.originAddressAdditional.modifierTwo),
              floor: (legData && legData.dropoffFloor) || (currentFormVal.originAddressAdditional && currentFormVal.originAddressAdditional.floor),
              room: (legData && legData.dropoffRoom) || (currentFormVal.originAddressAdditional && currentFormVal.originAddressAdditional.room),
              aptOrSuite: (legData && legData.dropoffApt) || (currentFormVal.originAddressAdditional && currentFormVal.originAddressAdditional.aptOrSuite),
              place: (legData && legData.dropoffLocationName) || (currentFormVal.originAddressAdditional && currentFormVal.originAddressAdditional.place),
              phone: (legData && legData.dropoffPhone) || (currentFormVal.originAddressAdditional && currentFormVal.originAddressAdditional.phone)
            }
          });

          // Timing for return/subsequent leg with direct priority
          const legPuStr = legData ? (legData.pickupTime || extracted.returnPickupTime) : extracted.returnPickupTime;
          const legApptStr = legData ? (legData.appointmentTime || legData.dropoffTime) : undefined;
          const parsedLegPu = this.parseTimeStringToMoment(legPuStr, baseDate);
          const parsedLegAppt = this.parseTimeStringToMoment(legApptStr, baseDate);
          const isLegWillCall = Boolean(legData ? legData.isWillCall : (extracted.isWillCall && !legPuStr));

          if (isLegWillCall) {
            // Set Will Call on pickup for the return leg
            const willCallTime = baseDate.clone().hour(23).minute(59).second(0);
            const legApptTime = parsedLegAppt || willCallTime;
            legGroup.patchValue({
              isWillCall: true,
              preScheduleTime: willCallTime,
              scheduleTime: willCallTime.toISOString(),
              preAppointmentTime: legApptTime,
              appointmentTime: legApptTime.toISOString()
            });
            if (legGroup.controls && legGroup.controls.preScheduleTime) {
              legGroup.controls.preScheduleTime.disable();
            }
          } else if (parsedLegPu && parsedLegAppt) {
            // 1. First priority: Both exist directly on leg
            legGroup.patchValue({
              isWillCall: false,
              preScheduleTime: parsedLegPu,
              scheduleTime: parsedLegPu.toISOString(),
              preAppointmentTime: parsedLegAppt,
              appointmentTime: parsedLegAppt.toISOString()
            });
            if (legGroup.controls && legGroup.controls.preScheduleTime) {
              legGroup.controls.preScheduleTime.enable();
            }
          } else if (parsedLegPu) {
            // 2. Only Pickup time exists on leg
            const apptMom = parsedLegPu.clone().add(travelMinutes || 60, 'minutes');
            legGroup.patchValue({
              isWillCall: false,
              preScheduleTime: parsedLegPu,
              scheduleTime: parsedLegPu.toISOString(),
              preAppointmentTime: apptMom,
              appointmentTime: apptMom.toISOString()
            });
            if (legGroup.controls && legGroup.controls.preScheduleTime) {
              legGroup.controls.preScheduleTime.enable();
            }
          } else if (parsedLegAppt) {
            // 3. Only Appt time exists on leg
            const puMom = parsedLegAppt.clone().subtract(travelMinutes || 60, 'minutes');
            legGroup.patchValue({
              isWillCall: false,
              preScheduleTime: puMom,
              scheduleTime: puMom.toISOString(),
              preAppointmentTime: parsedLegAppt,
              appointmentTime: parsedLegAppt.toISOString()
            });
            if (legGroup.controls && legGroup.controls.preScheduleTime) {
              legGroup.controls.preScheduleTime.enable();
            }
          }
        }
      }, 250);
    } else {
      // Single Way: remove all legs so only 1 single trip is created
      while (this.legForm.length > 0) {
        this.legForm.removeAt(0);
      }
    }

    // 11. Distance & Milage calculation
    setTimeout(() => {
      this.calculateSuggestedPickupTime();
      if (
        this.newTripForm.value.jobOriginLatitude &&
        this.newTripForm.value.jobOriginLongitude &&
        this.newTripForm.value.jobDestinationLatitude &&
        this.newTripForm.value.jobDestinationLongitude
      ) {
        this.getMiles();
      }
    }, 450);

    // 12. Attach File as Trip Attachment
    if (extracted._rawFile) {
      this.proTipsService.changeCoverImage(extracted._rawFile).toPromise()
        .then((res: any) => {
          if (res && res.location) {
            this.newTripForm.patchValue({ attachment: res.location });
          }
        })
        .catch((err: any) => {
          console.warn('Failed to upload file as attachment:', err);
        });
    }

    setTimeout(() => {
      this.isAiPopulating = false;
    }, 800);

    this.toastr.success('Trip form loaded successfully from document!', 'Success');
  }

  async calculatePuDoTime(isPuTimeChange: boolean = false, index?: number) {
    if (!this.isPuDoMileageBased) return;
    if (this.tripId && !this.isEditDataLoaded) return; // prevent calculation on edit trip form load

    const targetForm: FormGroup = index > -1
      ? ((this.newTripForm.get('tripLegs') as FormArray).at(index) as FormGroup)
      : this.newTripForm;

    if (!targetForm) return;

    const isWillCall = targetForm.get('isWillCall') && targetForm.get('isWillCall').value;
    if (isWillCall) return;

    const {
      jobOriginAddress,
      jobOriginLatitude,
      jobOriginLongitude,
      jobDestinationAddress,
      jobDestinationLatitude,
      jobDestinationLongitude,
    } = targetForm.getRawValue();

    // stop if any of the following doesn't have a value
    if (!(jobOriginAddress && jobDestinationAddress)) return;

    this.isUpdatingPuDoTime.index = index > -1 ? index : null;
    if (isPuTimeChange) {
      this.isUpdatingPuDoTime.dropoff = true;
    } else {
      this.isUpdatingPuDoTime.pickup = true;
    }
    this.cdr.markForCheck();

    const startTime = Date.now();
    const minAnimationMs = 1800;

    const queryParams = {
      start: [jobOriginLongitude, jobOriginLatitude].toString(),
      end: [jobDestinationLongitude, jobDestinationLatitude].toString(),
    };

    try {
      const minutes = await this.calculateTime(queryParams);
      console.log('minutes', minutes);
      if (isPuTimeChange) {
        const newScheduleTime = moment(targetForm.getRawValue().scheduleTime).tz(this.timeZone);
        const newAppointmentTime = newScheduleTime.clone().add(minutes, 'minutes');
        targetForm.get('preAppointmentTime').setValue(newAppointmentTime, {
          emitEvent: false,
          emitViewToModelChange: false,
        });
        targetForm.get('appointmentTime').setValue(newAppointmentTime.toISOString(), {
          emitEvent: false,
          emitViewToModelChange: false,
        });
        if (!(index > -1)) {
          this.calculateEstAppointmentTime();
        }
      } else {
        const newAppointmentTime = moment(targetForm.getRawValue().appointmentTime).tz(this.timeZone);
        const newScheduleTime = newAppointmentTime.clone().subtract(minutes, 'minutes');
        targetForm.get('preScheduleTime').setValue(newScheduleTime, {
          emitEvent: false,
          emitViewToModelChange: false,
        });
        targetForm.get('scheduleTime').setValue(newScheduleTime.toISOString(), {
          emitEvent: false,
          emitViewToModelChange: false,
        });
        if (!(index > -1)) {
          this.calculateEstAppointmentTime();
        }
      }
      this.cdr.markForCheck();
    } catch (error) {
    } finally {
      const elapsed = Date.now() - startTime;
      const remaining = Math.max(0, minAnimationMs - elapsed);
      if (remaining > 0) {
        await new Promise(resolve => {
          this.pudoAnimationTimeout = setTimeout(resolve, remaining);
        });
      }
      this.isUpdatingPuDoTime.pickup = false;
      this.isUpdatingPuDoTime.dropoff = false;
      this.isUpdatingPuDoTime.index = null;
      this.cdr.markForCheck();
    }
  }

  isPuDoUpdating(type: 'pickup' | 'dropoff', index?: number): boolean {
    if (!this.isUpdatingPuDoTime || !this.isUpdatingPuDoTime[type]) {
      return false;
    }
    if (index !== undefined && index > -1) {
      return this.isUpdatingPuDoTime.index === index;
    }
    return this.isUpdatingPuDoTime.index === null || this.isUpdatingPuDoTime.index === undefined || this.isUpdatingPuDoTime.index === -1;
  }

  getPuDoAnimationDirection(index?: number): 'to-dropoff' | 'to-pickup' | null {
    if (this.isPuDoUpdating('dropoff', index)) {
      return 'to-dropoff';
    }
    if (this.isPuDoUpdating('pickup', index)) {
      return 'to-pickup';
    }
    return null;
  }

  hasBothAddressAndCoords(index?: number): boolean {
    const targetForm = index > -1
      ? ((this.newTripForm.get('tripLegs') as FormArray).at(index))
      : this.newTripForm;
    if (!targetForm) return false;
    const formVal = targetForm.value || {};
    return !!(
      formVal.jobOriginAddress &&
      formVal.jobOriginLatitude &&
      formVal.jobOriginLongitude &&
      formVal.jobDestinationAddress &&
      formVal.jobDestinationLatitude &&
      formVal.jobDestinationLongitude
    );
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.updateTimeConnector();
  }

  scheduleUpdateConnector(delay: number = 100) {
    setTimeout(() => {
      this.updateTimeConnector();
    }, delay);
  }

  updateTimeConnector() {
    this.updateMainTimeConnector();
    this.updateLegTimeConnectors();
  }

  updateMainTimeConnector() {
    if (!this.showTimeConnector) {
      if (this.timeConnectorPath) {
        this.timeConnectorPath = '';
        this.timeConnectorMidX = 0;
        this.timeConnectorMidY = 0;
        this.cdr.markForCheck();
      }
      return;
    }

    if (!this.puDoContainer || !this.pickupTimeInputWrapper || !this.dropoffTimeInputWrapper) {
      return;
    }

    const containerEl = this.puDoContainer.nativeElement as HTMLElement;
    const puEl = this.pickupTimeInputWrapper.nativeElement as HTMLElement;
    const doEl = this.dropoffTimeInputWrapper.nativeElement as HTMLElement;

    if (!containerEl || !puEl || !doEl) {
      return;
    }

    const cRect = containerEl.getBoundingClientRect();
    const puRect = puEl.getBoundingClientRect();
    const doRect = doEl.getBoundingClientRect();

    if (puRect.width === 0 || doRect.width === 0 || cRect.width === 0) {
      return;
    }

    const x1 = Math.round(puRect.left - cRect.left);
    const y1 = Math.round(puRect.top - cRect.top + (puRect.height / 2));
    const x2 = Math.round(doRect.left - cRect.left);
    const y2 = Math.round(doRect.top - cRect.top + (doRect.height / 2));

    if (y2 <= y1) {
      return;
    }

    const inputLeft = Math.min(x1, x2);
    let stemX = inputLeft - 16;

    const cardEl = containerEl.closest('.card') as HTMLElement;
    if (cardEl) {
      const cardRect = cardEl.getBoundingClientRect();
      const cardLeftRel = cardRect.left - cRect.left;
      stemX = Math.max(Math.round(cardLeftRel + 18), stemX);
    }

    const radius = Math.min(12, Math.max(4, Math.floor((y2 - y1) / 4), Math.floor((inputLeft - stemX) / 2)));

    const newPath = `M ${x1} ${y1} H ${stemX + radius} Q ${stemX} ${y1} ${stemX} ${y1 + radius} V ${y2 - radius} Q ${stemX} ${y2} ${stemX + radius} ${y2} H ${x2}`;
    const midX = stemX;
    const midY = Math.round((y1 + y2) / 2);

    if (this.timeConnectorPath !== newPath || this.timeConnectorMidX !== midX || this.timeConnectorMidY !== midY) {
      this.timeConnectorPath = newPath;
      this.timeConnectorMidX = midX;
      this.timeConnectorMidY = midY;
      this.cdr.markForCheck();
    }
  }

  updateLegTimeConnectors() {
    if (!this.showTimeConnector) {
      if (this.legConnectorPaths.length > 0) {
        this.legConnectorPaths = [];
        this.legConnectorCenters = [];
        this.cdr.markForCheck();
      }
      return;
    }

    const legContainersArr = this.legContainers ? this.legContainers.toArray() : [];
    const legPickupWrappersArr = this.legPickupTimeWrappers ? this.legPickupTimeWrappers.toArray() : [];
    const legDropoffWrappersArr = this.legDropoffTimeWrappers ? this.legDropoffTimeWrappers.toArray() : [];

    const newLegPaths: string[] = [];
    const newLegCenters: { x: number; y: number }[] = [];

    for (let i = 0; i < legContainersArr.length; i++) {
      const containerItem = legContainersArr[i];
      const puItem = legPickupWrappersArr[i];
      const doItem = legDropoffWrappersArr[i];

      const legContainerEl = containerItem ? (containerItem.nativeElement as HTMLElement) : null;
      const legPuEl = puItem ? (puItem.nativeElement as HTMLElement) : null;
      const legDoEl = doItem ? (doItem.nativeElement as HTMLElement) : null;

      if (!legContainerEl || !legPuEl || !legDoEl) {
        newLegPaths.push('');
        newLegCenters.push({ x: 0, y: 0 });
        continue;
      }

      const legCRect = legContainerEl.getBoundingClientRect();
      const legPuRect = legPuEl.getBoundingClientRect();
      const legDoRect = legDoEl.getBoundingClientRect();

      if (legPuRect.width === 0 || legDoRect.width === 0 || legCRect.width === 0) {
        newLegPaths.push('');
        newLegCenters.push({ x: 0, y: 0 });
        continue;
      }

      const legX1 = Math.round(legPuRect.left - legCRect.left);
      const legY1 = Math.round(legPuRect.top - legCRect.top + (legPuRect.height / 2));
      const legX2 = Math.round(legDoRect.left - legCRect.left);
      const legY2 = Math.round(legDoRect.top - legCRect.top + (legDoRect.height / 2));

      if (legY2 <= legY1) {
        newLegPaths.push('');
        newLegCenters.push({ x: 0, y: 0 });
        continue;
      }

      const legInputLeft = Math.min(legX1, legX2);
      let legStemX = legInputLeft - 26;

      const legCardEl = legContainerEl.closest('.card') as HTMLElement;
      if (legCardEl) {
        const legCardRect = legCardEl.getBoundingClientRect();
        const legCardLeftRel = legCardRect.left - legCRect.left;
        legStemX = Math.max(Math.round(legCardLeftRel + 8), legStemX);
      }

      const legRadius = Math.min(12, Math.max(4, Math.floor((legY2 - legY1) / 4), Math.floor((legInputLeft - legStemX) / 2)));
      const legPath = `M ${legX1} ${legY1} H ${legStemX + legRadius} Q ${legStemX} ${legY1} ${legStemX} ${legY1 + legRadius} V ${legY2 - legRadius} Q ${legStemX} ${legY2} ${legStemX + legRadius} ${legY2} H ${legX2}`;

      newLegPaths.push(legPath);
      newLegCenters.push({ x: legStemX, y: Math.round((legY1 + legY2) / 2) });
    }

    let hasChanged = false;
    if (newLegPaths.length !== this.legConnectorPaths.length) {
      hasChanged = true;
    } else {
      for (let i = 0; i < newLegPaths.length; i++) {
        const curCenter = this.legConnectorCenters[i];
        const newCenter = newLegCenters[i];
        if (
          newLegPaths[i] !== this.legConnectorPaths[i] ||
          !curCenter ||
          !newCenter ||
          newCenter.x !== curCenter.x ||
          newCenter.y !== curCenter.y
        ) {
          hasChanged = true;
          break;
        }
      }
    }

    if (hasChanged) {
      this.legConnectorPaths = newLegPaths;
      this.legConnectorCenters = newLegCenters;
      this.cdr.markForCheck();
    }
  }

  toggleCalulatePuDo() {
    this.isCalulatePuDo = !this.isCalulatePuDo;
    if (this.isCalulatePuDo && this.isEnableExpectedAppointment) {
      this.isEnableExpectedAppointment = false;
      this.clearExpectedAppointmentValidation();
    }
    this.scheduleUpdateConnector(50);
  }

  toggleExpectedAppointment() {
    this.isEnableExpectedAppointment = !this.isEnableExpectedAppointment;
    if (!this.isEnableExpectedAppointment) {
      this.clearExpectedAppointmentValidation();
    } else {
      // expected appointment drives PU/DO times, so sync must be off
      if (this.isCalulatePuDo) {
        this.isCalulatePuDo = false;
        this.scheduleUpdateConnector(50);
      }
      this.form.preActualAppointmentTime.setValidators(Validators.required);
      this.form.preActualAppointmentTime.updateValueAndValidity();
    }
  }

  clearExpectedAppointmentValidation() {
    this.suggestedPickupTime = null;
    this.form.preActualAppointmentTime.clearValidators();
    this.form.preActualAppointmentTime.patchValue("");
    this.form.preActualAppointmentTime.updateValueAndValidity();
    this.form.actualAppointmentTime.patchValue("");
    this.form.actualAppointmentTime.updateValueAndValidity();
  }
}
